import { RemoteRemovePersonFromGroup } from 'data/usecases';
import { RemovePersonFromGroupUseCaseInterface } from 'domain/usecases';
import { makeApiUrlRemovePersonFromGroup } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteRemovePersonFromGroup =
  (): RemovePersonFromGroupUseCaseInterface =>
    new RemoteRemovePersonFromGroup(
      makeApiUrlRemovePersonFromGroup(),
      makeAxiosHttpClient(),
    );
